// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.boxx-panel-widget .title {
  display: flex;
  align-items: center;
  margin-top: 24px;
  margin-bottom: 10px;
  margin-left: 8px;
  line-height: 1;
}
.boxx-panel-widget .title ::ng-deep *[title] {
  font-size: 21px;
  font-weight: 700;
}
.boxx-panel-widget .subtitle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
  margin: 16px 8px;
}
.boxx-panel-widget .subtitle:empty {
  display: none;
}
.boxx-panel-widget .subtitle ::ng-deep *[link] {
  display: flex;
  align-items: center;
  text-transform: none;
  font-weight: 500;
}
.boxx-panel-widget .subtitle ::ng-deep *[link] ion-icon {
  width: 16px;
  margin-left: 5px !important;
}`, "",{"version":3,"sources":["webpack://./src/modules/@boxx/panel-core/lib/components/panel-widget/panel-widget.component.scss"],"names":[],"mappings":"AACE;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;AAAJ;AAEI;EACE,eAAA;EACA,gBAAA;AAAN;AAIE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,gBAAA;AAFJ;AAII;EACE,aAAA;AAFN;AAKI;EACE,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;AAHN;AAKM;EACE,WAAA;EACA,2BAAA;AAHR","sourcesContent":[".boxx-panel-widget {\n  .title {\n    display: flex;\n    align-items: center;\n    margin-top: 24px;\n    margin-bottom: 10px;\n    margin-left: 8px;\n    line-height: 1;\n\n    ::ng-deep *[title] {\n      font-size: 21px;\n      font-weight: 700;\n    }\n  }\n\n  .subtitle {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    font-size: 14px;\n    font-weight: 700;\n    text-transform: uppercase;\n    margin: 16px 8px;\n\n    &:empty {\n      display: none;\n    }\n\n    ::ng-deep *[link] {\n      display: flex;\n      align-items: center;\n      text-transform: none;\n      font-weight: 500;\n\n      ion-icon {\n        width: 16px;\n        margin-left: 5px !important;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
